import styled, { css } from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

const MIN_OPTIONS_LENGTH_FOR_PADDING = 11
export const CheckBoxWrapper = styled.div<{ optionsLength?: number }>`
  &:first-child > div {
    margin: 0;

    ${({ optionsLength }) =>
      optionsLength &&
      optionsLength < MIN_OPTIONS_LENGTH_FOR_PADDING &&
      css`
        padding: 10px;
      `}
  }
`

export const CheckBoxOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;

  span {
    color: ${mainColors.neutralExtremelyDark};
  }
`
